(function () {
  var BT = window.BT || {};
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function money(cents) {
    var s = (cents / 100).toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    var f = BT.moneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (k.indexOf('comma') > -1) return s.replace('.', ',');
      return s;
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shipCopy(total) {
    return total >= BT.freeShip
      ? 'You\u2019ve unlocked free US shipping.'
      : 'You\u2019re ' + money(BT.freeShip - total) + ' away from free US shipping.';
  }

  /* ---------- Bag drawer ---------- */
  var drawer = document.getElementById('bt-bag');
  var lastFocus = null;

  function openBag() {
    if (!drawer) { window.location.href = '/cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var c = drawer.querySelector('[data-bag-close]');
    if (c) c.focus();
  }
  function closeBag() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus) lastFocus.focus();
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-ship-note]').forEach(function (el) {
      el.textContent = cart.total_price >= BT.freeShip ? 'Your order ships free.' : 'Free US shipping on orders over ' + money(BT.freeShip) + '.';
    });
    if (!drawer) return;
    drawer.querySelector('[data-ship-msg]').textContent = shipCopy(cart.total_price);
    drawer.querySelector('[data-ship-bar]').style.width = Math.min(100, (cart.total_price / BT.freeShip) * 100) + '%';
    drawer.querySelector('[data-subtotal]').textContent = money(cart.total_price);
    var empty = cart.item_count === 0;
    drawer.querySelector('[data-bag-empty]').hidden = !empty;
    drawer.querySelector('[data-bag-foot]').hidden = empty;
    drawer.querySelector('[data-bag-lines]').innerHTML = cart.items.map(function (it) {
      var note = '';
      if (it.selling_plan_allocation) note = 'Subscription \u00b7 ' + it.selling_plan_allocation.selling_plan.name;
      else if (/starter set|bundle/i.test(it.product_type || '')) note = 'Starter set';
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '';
      var variant = it.product_has_only_default_variant ? '' : '<div class="bt-small">' + esc(it.variant_title) + '</div>';
      return '<div class="bt-line">' +
        '<a class="bt-img" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div class="bt-stack-8" style="gap:6px">' +
          '<a class="bt-line__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          (note ? '<div class="bt-line__note">' + esc(note) + '</div>' : '') +
          '<div class="bt-line__qty">' +
            '<button type="button" data-line-change data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">\u2013</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-line-change data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="bt-price">' + money(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
  }

  function refreshCart() {
    return fetch(BT.routes.cart, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(BT.routes.cartAdd, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { alert(res.j.description || res.j.message || 'Could not add to bag.'); return; }
        return refreshCart().then(function () { if (BT.openOnAdd) openBag(); });
      })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  function changeLine(key, qty) {
    return fetch(BT.routes.cartChange, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bag-open]')) { e.preventDefault(); openBag(); return; }
    if (t.closest('[data-bag-close]')) { e.preventDefault(); closeBag(); return; }
    var q = t.closest('[data-quick-add]');
    if (q) { e.preventDefault(); addToCart([{ id: Number(q.dataset.quickAdd), quantity: 1 }], q); return; }
    var ch = t.closest('[data-line-change]');
    if (ch) { changeLine(ch.dataset.key, Number(ch.dataset.qty)); return; }
    var mb = t.closest('[data-menu-toggle]');
    if (mb) {
      var h = mb.closest('.bt-header');
      var open = h.classList.toggle('is-open');
      mb.setAttribute('aria-expanded', open);
      mb.textContent = open ? 'Close' : 'Menu';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeBag();
    if (popup && !popup.hidden) closePopup();
  });

  /* ---------- Product form ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var form = root.querySelector('form[data-product-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name=id]');
    var variantSel = form.querySelector('[data-variant]');
    var qtyEl = form.querySelector('[data-qty]');
    var totalEl = form.querySelector('[data-total]');
    var addBtn = form.querySelector('[data-add]');
    var addLabel = form.querySelector('[data-add-label]');
    var dataEl = root.querySelector('[data-variants-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var qty = 1;

    function variant() {
      var id = Number(idInput.value);
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }
    function planId() {
      var p = form.querySelector('input[name=purchase]:checked');
      if (!p || p.value !== 'sub') return null;
      var s = form.querySelector('input[name=selling_plan]:checked');
      return s ? Number(s.value) : null;
    }
    function unitPrice(v, pid) {
      if (pid && v.selling_plan_allocations) {
        for (var i = 0; i < v.selling_plan_allocations.length; i++) {
          if (v.selling_plan_allocations[i].selling_plan_id === pid) return v.selling_plan_allocations[i].price;
        }
      }
      return v.price;
    }
    function update() {
      var v = variant();
      if (!v) return;
      var pid = planId();
      totalEl.textContent = money(unitPrice(v, pid) * qty);
      qtyEl.textContent = qty;
      form.querySelectorAll('[data-price-once]').forEach(function (el) { el.textContent = money(v.price); });
      var subPlan = form.querySelector('input[name=selling_plan]:checked');
      if (subPlan) form.querySelectorAll('[data-price-sub]').forEach(function (el) { el.textContent = money(unitPrice(v, Number(subPlan.value))); });
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
    }

    form.addEventListener('change', function (e) {
      if (e.target === variantSel) {
        idInput.value = variantSel.value;
        var v = variant();
        if (v && v.featured_media) swapMain(root, v.featured_media.preview_image.src);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantSel.value);
        history.replaceState({}, '', url);
      }
      update();
    });
    form.querySelector('[data-qty-inc]').addEventListener('click', function () { qty++; update(); });
    form.querySelector('[data-qty-dec]').addEventListener('click', function () { qty = Math.max(1, qty - 1); update(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var item = { id: Number(idInput.value), quantity: qty };
      var pid = planId();
      if (pid) item.selling_plan = pid;
      addToCart([item], addBtn);
    });

    root.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        swapMain(root, b.dataset.thumb);
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b); });
      });
    });
    update();
  }
  function swapMain(root, src) {
    var img = root.querySelector('.bt-gallery__main img');
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1400';
  }

  /* ---------- Recommendations ---------- */
  function initRecs(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    fetch(el.dataset.recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recs-url]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        else el.closest('.shopify-section').hidden = true;
      });
  }

  /* ---------- Email popup ---------- */
  var popup = document.getElementById('bt-popup');
  var KEY = 'bt-email-popup';
  function seen() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }
  function closePopup() { if (popup) { popup.hidden = true; remember(); } }
  if (popup) {
    var posted = /customer_posted=true/.test(location.search) && location.hash === '#bt-popup-form';
    if (posted || popup.querySelector('[data-popup-error]')) {
      popup.hidden = false;
    } else if (!seen() && !(window.Shopify && window.Shopify.designMode)) {
      setTimeout(function () { if (!seen()) popup.hidden = false; }, Number(popup.dataset.delay || 2.5) * 1000);
    }
    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('[data-popup-close]')) closePopup();
    });
    var pf = popup.querySelector('form');
    if (pf) pf.addEventListener('submit', remember);
  }
  document.querySelectorAll('[data-email-form]').forEach(function (f) { f.addEventListener('submit', remember); });

  /* ---------- Init ---------- */
  function init(scope) {
    (scope || document).querySelectorAll('[data-bt-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-recs-url]').forEach(initRecs);
  }
  init();
  refreshCart();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
